var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticStyle: { position: "relative", display: "inline-block" } },
    [
      _c("i", {
        staticClass: "el-icon-arrow-down el-icon-delete",
        staticStyle: {
          position: "absolute",
          top: "6px",
          right: "24px",
          color: "#878d9f",
          cursor: "pointer",
          "z-index": "1",
        },
        on: { click: _vm.removeItem },
      }),
      _c(
        "el-dropdown",
        {
          attrs: { trigger: "click", size: "mini" },
          on: { command: _vm.clickItem },
        },
        [
          _c(
            "span",
            { staticClass: "el-dropdown-link" },
            [
              _c(
                "el-tag",
                {
                  staticClass: "item-axis",
                  attrs: { size: "small", type: _vm.tagType },
                },
                [
                  _c(
                    "span",
                    { staticStyle: { float: "left" } },
                    [
                      _vm.item.deType === 0
                        ? _c("svg-icon", {
                            staticClass: "field-icon-text",
                            attrs: { "icon-class": "field_text" },
                          })
                        : _vm._e(),
                      _vm.item.deType === 1
                        ? _c("svg-icon", {
                            staticClass: "field-icon-time",
                            attrs: { "icon-class": "field_time" },
                          })
                        : _vm._e(),
                      _vm.item.deType === 2 || _vm.item.deType === 3
                        ? _c("svg-icon", {
                            staticClass: "field-icon-value",
                            attrs: { "icon-class": "field_value" },
                          })
                        : _vm._e(),
                      _vm.item.deType === 5
                        ? _c("svg-icon", {
                            staticClass: "field-icon-location",
                            attrs: { "icon-class": "field_location" },
                          })
                        : _vm._e(),
                      _vm.item.sort === "asc"
                        ? _c("svg-icon", {
                            attrs: {
                              "icon-class": "sort-asc",
                              "class-name": "field-icon-sort",
                            },
                          })
                        : _vm._e(),
                      _vm.item.sort === "desc"
                        ? _c("svg-icon", {
                            attrs: {
                              "icon-class": "sort-desc",
                              "class-name": "field-icon-sort",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "item-span-style",
                      attrs: { title: _vm.item.name },
                    },
                    [_vm._v(_vm._s(_vm.item.name))]
                  ),
                  _vm.tagType === "danger" ? _c("field-error-tips") : _vm._e(),
                  false && _vm.item.deType === 1
                    ? _c("span", { staticClass: "summary-span" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("chart." + _vm.item.dateStyle)) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _c("i", {
                    staticClass: "el-icon-arrow-down el-icon--right",
                    staticStyle: {
                      position: "absolute",
                      top: "6px",
                      right: "10px",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "el-dropdown",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placement: "right-start", size: "mini" },
                          on: { command: _vm.sort },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "el-dropdown-link inner-dropdown-menu",
                            },
                            [
                              _c("span", [
                                _c("i", { staticClass: "el-icon-sort" }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chart.sort"))),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "summary-span-item" },
                                  [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.$t("chart." + _vm.item.sort)
                                        ) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ]),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-right el-icon--right",
                              }),
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: _vm.beforeSort("none") } },
                                [_vm._v(_vm._s(_vm.$t("chart.none")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: _vm.beforeSort("asc") } },
                                [_vm._v(_vm._s(_vm.$t("chart.asc")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: _vm.beforeSort("desc") } },
                                [_vm._v(_vm._s(_vm.$t("chart.desc")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.item.deType === 1,
                          expression: "item.deType === 1",
                        },
                      ],
                      attrs: { divided: "" },
                    },
                    [
                      _c(
                        "el-dropdown",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placement: "right-start", size: "mini" },
                          on: { command: _vm.dateStyle },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "el-dropdown-link inner-dropdown-menu",
                            },
                            [
                              _c("span", [
                                _c("i", {
                                  staticClass: "el-icon-c-scale-to-original",
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chart.dateStyle"))),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "summary-span-item" },
                                  [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.$t("chart." + _vm.item.dateStyle)
                                        ) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ]),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-right el-icon--right",
                              }),
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: { command: _vm.beforeDateStyle("y") },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.y")))]
                              ),
                              _vm.showDateExt
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.beforeDateStyle("y_Q"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.y_Q")))]
                                  )
                                : _vm._e(),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeDateStyle("y_M"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.y_M")))]
                              ),
                              _vm.showDateExt
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.beforeDateStyle("y_W"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.y_W")))]
                                  )
                                : _vm._e(),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeDateStyle("y_M_d"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.y_M_d")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeDateStyle("H_m_s"),
                                    divided: "",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.H_m_s")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeDateStyle("y_M_d_H_m"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.y_M_d_H_m")))]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeDateStyle("y_M_d_H_m_s"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.y_M_d_H_m_s")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.item.deType === 1,
                          expression: "item.deType === 1",
                        },
                      ],
                    },
                    [
                      _c(
                        "el-dropdown",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placement: "right-start", size: "mini" },
                          on: { command: _vm.datePattern },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "el-dropdown-link inner-dropdown-menu",
                            },
                            [
                              _c("span", [
                                _c("i", { staticClass: "el-icon-timer" }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chart.datePattern"))),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "summary-span-item" },
                                  [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.$t(
                                            "chart." + _vm.item.datePattern
                                          )
                                        ) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ]),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-right el-icon--right",
                              }),
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeDatePattern("date_sub"),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("chart.date_sub")) +
                                      "(1990-01-01)"
                                  ),
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command:
                                      _vm.beforeDatePattern("date_split"),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("chart.date_split")) +
                                      "(1990/01/01)"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        icon: "el-icon-edit-outline",
                        divided: "",
                        command: _vm.beforeClickItem("rename"),
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chart.show_name_set"))),
                      ]),
                    ]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        icon: "el-icon-delete",
                        divided: "",
                        command: _vm.beforeClickItem("remove"),
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("chart.delete")))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }